var map = {
	"./stage-bright-purple.png": 17653,
	"./stage-green.png": 31351,
	"./stage-light-claret.png": 90398,
	"./stage-main-bg-color.png": 27833,
	"./stage-secondary-color.png": 62234,
	"./stage-tech-red.png": 57506,
	"./stage.png": 34965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78346;